/* eslint-disable quote-props */
import { Alert, styled } from "@mui/material";

import { paletteColors } from "../muiTheme";

const AlertCustom = styled(Alert)(({ theme }) => ({
  alignItems: "center",
  fontWeight: 600,
  minWidth: "21.875rem",
  maxWidth: "27rem",
  [theme.breakpoints.down("sm")]: {
    minWidth: "75%",
  },
  display: "flex",
  "& .MuiAlert-message": {
    width: "100% !important",
  },
  justifyContent: "space-between",
  "&.MuiAlert-root": {
    padding: "0.25rem 0.5rem",
  },
  "&.MuiAlert-standardError": {
    backgroundColor: theme.palette.error.light,
    color: paletteColors.black.main,
    border: `1px solid ${theme.palette.error.main}`,
  },
  "&.MuiAlert-standardError .MuiAlert-icon": {
    color: paletteColors.black.main,
  },
  "&.MuiAlert-standardWarning": {
    backgroundColor: theme.palette.warning.light,
    color: paletteColors.black.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },
  "&.MuiAlert-standardWarning .MuiAlert-icon": {
    color: paletteColors.black.main,
  },
  "&.MuiAlert-standardInfo": {
    backgroundColor: theme.palette.info.light,
    color: paletteColors.black.main,
    border: `1px solid ${paletteColors.purple.main}`,
  },
  "&.MuiAlert-standardInfo .MuiAlert-icon": {
    color: paletteColors.black.main,
  },
  "&.MuiAlert-standardSuccess": {
    backgroundColor: theme.palette.primary.light,
    color: paletteColors.black.main,
    border: `1px solid ${paletteColors.primary.dark}`,
  },
  "&.MuiAlert-standardSuccess .MuiAlert-icon": {
    color: paletteColors.black.main,
  },
  // Custom Alert Type: Update Payment Alert
  "&.MuiAlert-standardupdatePaymentAlert": {
    backgroundColor: paletteColors.torquise.light, // Adjust color
    color: paletteColors.black.main,
    border: `1px solid ${paletteColors.torquise.main}`, // Adjust border color
  },
  "&.MuiAlert-standardupdatePaymentAlert .MuiAlert-icon": {
    color: paletteColors.black.main,
  },
}));

export default AlertCustom;
